import { useMemo, useState } from "react";
import { OverlayViewF } from "@react-google-maps/api";
import { getMultiUnitGridABTestingVariant, MultiUnitGridABTestVariants } from "@/app/src/hooks/useMultiUnitGridABTesting";
import HighlightedPropertyBoxMobile from "@template/Search/HighlightedPropertyBoxMobile";
import { PropertyDataV2 } from "commonModule/services/common";
import { CountApiListOfAllProperties } from "commonModule/services/search";
import { useAppSelector } from "stores/hooks";
import { selectHoveredPropertyId, selectOpenedPropertyCardInMapBox } from "stores/ui/uiSlice";
import Marker from "./Marker";
const radius = 0.00012; // spreadout circles radius
function getCircularOffset(index: number, total: number) {
  const angle = index / total * 2 * Math.PI * 4;
  return {
    x: radius * Math.cos(angle),
    y: radius * Math.sin(angle)
  };
}
const InnerMap = ({
  properties,
  propertyListWithLatLng
}: {
  properties: PropertyDataV2[];
  propertyListWithLatLng: CountApiListOfAllProperties[];
}) => {
  const hoveredPropertyId = useAppSelector(selectHoveredPropertyId);
  const openedPropertyCardId = useAppSelector(selectOpenedPropertyCardInMapBox);
  const [propertyData, setPropertyData] = useState<PropertyDataV2[]>([]);
  const multiUnitCollapsedEnabled = useMemo(() => getMultiUnitGridABTestingVariant() === MultiUnitGridABTestVariants.MULTI_UNIT, []);
  const getPropertyData = (data: React.SetStateAction<PropertyDataV2[]>) => {
    setPropertyData(data);
  };
  return <>
      {properties.map((property, index) => {
      // A property should only be shown as multi-unit if there is more than one unit available.
      // If only one unit exists, it should display as a single property directly, without showing a multi-unit card.
      const matchedProperty = propertyListWithLatLng?.find(item => item.id === property._id // Match property ID with count API response id
      );
      // if count > 1, set hasMultiple to show multi-unit property items
      const hasMultiple = (matchedProperty?.count || 0) > 1;
      const shouldSpreadOut = !!properties.find((otherProperty, otherIndex) => {
        if (otherIndex === index) return false;
        const xDistance = Math.abs(otherProperty.longitude - property.longitude);
        const yDistance = Math.abs(otherProperty.latitude - property.latitude);
        const distance = xDistance + yDistance;
        if (distance < 0.0001) return true;
        return false;
      });
      const lat = property.latitude;
      const lng = property.longitude;
      const offset = !shouldSpreadOut || property.multiUnitGrp ? {
        x: 0,
        y: 0
      } : getCircularOffset(index, properties.length);
      return (
        // NOTE: Here we are using OverlayViewF instead of OverlayView because OverlayView is not working as expected. When OverlayView is used, the map markers flickers when the map is dragged. OverlayViewF is a workaround for this issue.
        <OverlayViewF key={`${property._id}`} mapPaneName={"overlayMouseTarget"} position={{
          lat: lat + offset.y,
          lng: lng + offset.x
        }} zIndex={openedPropertyCardId === property._id ? 20 : property._id === hoveredPropertyId ? 9 : 8}>
            <Marker property={property} isHovered={property._id === hoveredPropertyId} propertyIndex={index} hasMultiple={!multiUnitCollapsedEnabled ? true : hasMultiple} getPropertyData={getPropertyData} multiUnitCollapsedEnabled={multiUnitCollapsedEnabled} />
          </OverlayViewF>
      );
    })}
      <HighlightedPropertyBoxMobile properties={properties} propertyListWithLatLng={propertyListWithLatLng} propertyData={propertyData} getPropertyData={getPropertyData} multiUnitCollapsedEnabled={multiUnitCollapsedEnabled} data-sentry-element="HighlightedPropertyBoxMobile" data-sentry-source-file="InnerMap.tsx" />
    </>;
};
export default InnerMap;